export const CLIENT_ID = 1;
export const CLIENT_SECRET = 'VoQoD8lODMd0hT9m5M2aGib769cjLCti2gZAtFos';


// WEBPACK FOOTER //
// ./resources/assets/js/config.js